import { ButtonPopup } from '../../ui'; // Importa un botón estilizado reutilizable
import { ContactBlockCss } from '../../styles'; // Estilos CSS específicos del bloque de contacto
import { SvgWhatsapp } from '@/icons';

// Props que acepta el componente
type ContactoHorarioProps = {
  onClose?: () => void; // Función opcional que se ejecuta al cerrar el popup
  className?: string;   // Clase CSS adicional opcional
};

const ContactoHorario: React.FC<ContactoHorarioProps> = ({ onClose, className }) => {
  return (
    <div
      className={`
    relative
    bg-black text-white
    p-6 rounded-2xl shadow-2xl
    flex flex-col gap-3 text-start
    ${ContactBlockCss.contacto}
    ${className}
  `}
    >
      {/* Título del bloque */}
      <h2 className="text-xl font-bold text-center">Horario de Atención</h2>

      {/* Información de contacto */}
      {/*  <p><strong>Dirección:</strong> Calle Oropesa 11, Yuncos (Toledo)</p> */}
   <p className="flex items-center flex-wrap gap-2">
  <strong>Teléfono:</strong>

  <span>925 004 105</span>

  <a
    href="https://wa.me/34671562558?text=Quiero%20mi%20cupón."
    target="_blank"
    rel="noopener noreferrer"
    className="
      inline-flex items-center gap-2
      px-3 py-0.5 rounded-full
      bg-green-500/10
      shadow-[0_0_10px_rgba(34,197,94,0.2)]
      hover:shadow-[0_0_20px_rgba(34,197,94,0.5)]
      transition-all duration-500
    "
  >
    <SvgWhatsapp
      className="text-green-400 drop-shadow-[0_0_6px_rgba(34,197,94,0.7)]"
      height={18}
      width={18}
    />

    <span className="text-blue-300 font-medium text-sm leading-none">
      671 562 558
    </span>
  </a>
</p>
      <p>
        <strong>Email:</strong>{' '}
        <a
          href="mailto:contacto@linkservs.com"
          className="
      text-blue-400
      hover:text-green-400
      underline
      transition-colors duration-200
    "
        >
          contacto@linkservs.com
        </a>
      </p>
      <p>Lunes a Viernes, 9:00 - 18:00 PM</p>

      {/* Botón de cerrar popup */}
      {onClose && (
        <ButtonPopup
          onClick={onClose}
          className='mt-4 shadow-md hover:shadow-red-600'
        >
          Cerrar
        </ButtonPopup>
      )}
    </div>
  );
};

export default ContactoHorario;
